export default __webpack_public_path__ + "0a151d812de96a88b61817736b079cb0.png";